export const light = {
    bodyBg: "#E4EBFA",
    navBarBg: "white",
    asideBg: "white",
    taskBg: "white",
    scrollBg: "white",
    // sub task checkbox
    subTaskCheckBoxBg: "#F4F7FD",
    subTaskCheckBoxHover: "#979797",

    checkBoxBg: "white",
    completedCheckBoxBg: "#635FC7",
    // input field

    textFieldError: "#EA5555",

    // drop down
    dropDownBorder: "#828FA3",
    dropDownActive: "#635FC7",
    dropDownBg: "white",

    // buttons
    buttonPrimaryBg: "635FC7",
    buttonPrimaryHover: "A8A4FF",
    buttonPrimaryText: "white",
    buttonSecondaryBg: "635FC7",
    buttonSecondaryText: "635FC7",
    buttonSecondaryHover: "635FC7",
    deleteButtonBg: "EA5555",
    deleteButtonText: "white",
    deleteButtonHover: "FF9898",


    // text

    textPrimary: "black",

    //shard
    border: "rgba(0, 0, 0, 0.15)",
    grey: "#828fa3",
    blue: "#635FC7",
    lightBlue: "#A8A4FF",

}

export const dark = {
    bodyBg: "#20212C",
    asideBg: "#2B2C37",
    navBarBg: "#2B2C37",
    taskBg: "#2B2C37",
    scrollBg: "#2B2C37",
    
    // sub task checkbox
    subTaskCheckBoxBg: "#20212C",
    subTaskCheckBoxHover: "#635FC7",

    checkBoxBg: "2B2C37",
    completedCheckBoxBg: "#635FC7",
    // input field

    textFieldError: "#EA5555",
    // drop down
    dropDownIdle: "#828FA3",
    dropDownActive: "#635FC7",
    dropDownBg: "#20212C",


    // buttons
    buttonPrimaryBg: "#635FC7",
    buttonPrimaryHover: "A8A4FF",
    buttonSecondaryBg: "#635FC7",
    buttonSecondaryText: "#635FC7",
    buttonSecondaryHover: "#635FC7",
    deleteButtonBg: "EA5555",
    deleteButtonHover: "FF9898",

    // text

    textPrimary: "white",

    // shared

    border: "#3E3F4E",
    grey: "#828fa3",
    blue: "#635FC7",
    lightBlue: "#A8A4FF",
    
} 